module.exports = __webpack_public_path__ + "img/news10-1.8c72977d.png";